import { mediaApi as api } from "../Api";
import setupInterceptors from "../setupInterceptors";

const mediaSetupInterceptors = () => {
  return setupInterceptors(api);
};

export default mediaSetupInterceptors;
